import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#0A0A0A] text-[#F3F1ED]">
      {/* CTA Section */}
      <div className="border-b border-[#2A2A2A] py-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          {/* SIMPLIFIED CENTER WRAPPER */}
          <div className="flex flex-col items-center text-center">
            {/* Icon */}
            <div className="w-16 h-16 flex items-center justify-center bg-[#C7A86A]/10 rounded-full mb-4">
              <i className="ri-calendar-check-line text-[#C7A86A] text-2xl w-6 h-6 flex items-center justify-center"></i>
            </div>

            {/* Heading */}
            <h2 className="text-3xl lg:text-4xl font-serif mb-3">
              Klaar om uw cinewall te bespreken?
            </h2>

            {/* Text */}
            <p className="text-[#BFBFBF] text-lg mb-5 max-w-2xl">
              Specialist in luxe cinewalls op maat – ontwerp, productie & montage
            </p>

            {/* BUTTONS - ABSOLUTE CENTER */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <Link
                to="/cinewall-showroom"
                className="bg-[#C7A86A] text-[#0F0F0F] px-8 py-3.5 rounded-md font-semibold text-base hover:bg-[#B89858] transition-all duration-300 shadow-lg shadow-[#C7A86A]/20 whitespace-nowrap"
              >
                Plan showroomafspraak
              </Link>
              <Link
                to="/cinewall-configurator"
                className="border border-[#C7A86A] text-[#C7A86A] px-8 py-3.5 rounded-md font-semibold text-base hover:bg-[#C7A86A]/10 transition-all duration-300 whitespace-nowrap"
              >
                Offerte aanvragen in 1 min
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Logo & Description */}
          <div className="lg:col-span-1">
            <div className="bg-white px-4 py-2.5 rounded-md inline-block mb-4">
              <div className="flex flex-col items-center">
                <span className="text-[#0F0F0F] font-bold text-xl leading-tight tracking-tight">CINEWALL</span>
                <span className="text-[#C7A86A] font-semibold text-xs leading-tight tracking-wide">kopen</span>
              </div>
            </div>
            <p className="text-[#BFBFBF] text-sm leading-relaxed">
              Specialist in luxe cinewalls op maat. Van ontwerp tot montage begeleiden wij u persoonlijk en professioneel.
            </p>
          </div>

          {/* Diensten */}
          <div>
            <h3 className="text-[#F3F1ED] font-semibold mb-4 text-sm uppercase tracking-wider">
              Diensten
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/cinewall-op-maat"
                  className="text-[#BFBFBF] hover:text-[#C7A86A] transition-colors text-sm"
                >
                  Cinewall op maat
                </Link>
              </li>
              <li>
                <Link
                  to="/cinewall-configurator"
                  className="text-[#BFBFBF] hover:text-[#C7A86A] transition-colors text-sm"
                >
                  Offerte aanvragen
                </Link>
              </li>
              <li>
                <Link
                  to="/cinewall-met-haard"
                  className="text-[#BFBFBF] hover:text-[#C7A86A] transition-colors text-sm"
                >
                  Cinewall met haard
                </Link>
              </li>
              <li>
                <Link
                  to="/cinewall-met-haard-techniek"
                  className="text-[#BFBFBF] hover:text-[#C7A86A] transition-colors text-sm"
                >
                  Techniek & veiligheid
                </Link>
              </li>
              <li>
                <Link
                  to="/cinewall-prijs"
                  className="text-[#BFBFBF] hover:text-[#C7A86A] transition-colors text-sm"
                >
                  Prijzen
                </Link>
              </li>
            </ul>
          </div>

          {/* Informatie */}
          <div>
            <h3 className="text-[#F3F1ED] font-semibold mb-4 text-sm uppercase tracking-wider">
              Informatie
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/cinewall-inspiratie"
                  className="text-[#BFBFBF] hover:text-[#C7A86A] transition-colors text-sm"
                >
                  Inspiratie
                </Link>
              </li>
              <li>
                <Link
                  to="/cinewall-showroom"
                  className="text-[#BFBFBF] hover:text-[#C7A86A] transition-colors text-sm"
                >
                  Showroom
                </Link>
              </li>
              <li>
                <Link
                  to="/cinewall-faq"
                  className="text-[#BFBFBF] hover:text-[#C7A86A] transition-colors text-sm"
                >
                  Veelgestelde vragen
                </Link>
              </li>
              <li>
                <Link
                  to="/cinewall-configurator"
                  className="text-[#BFBFBF] hover:text-[#C7A86A] transition-colors text-sm"
                >
                  Offerte aanvragen
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-[#F3F1ED] font-semibold mb-4 text-sm uppercase tracking-wider">
              Contact
            </h3>
            <ul className="space-y-3 text-sm text-[#BFBFBF]">
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-[#C7A86A] mt-0.5 w-4 h-4 flex items-center justify-center"></i>
                <div>
                  <a href="tel:+31624172293" className="hover:text-[#C7A86A] transition-colors block">
                    +31(0) 62 417 22 93
                  </a>
                  <a href="tel:+31307810110" className="hover:text-[#C7A86A] transition-colors block">
                    +31(0) 30 781 01 10
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-[#C7A86A] mt-0.5 w-4 h-4 flex items-center justify-center"></i>
                <a href="mailto:info@cinewallkopen.nl" className="hover:text-[#C7A86A] transition-colors">
                  info@cinewallkopen.nl
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line text-[#C7A86A] mt-0.5 w-4 h-4 flex items-center justify-center"></i>
                <div>
                  <span className="block">Ma-Vr: 10:00-17:00</span>
                  <span className="block">Za-Zo: 10:00-18:00</span>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-[#C7A86A] mt-0.5 w-4 h-4 flex items-center justify-center"></i>
                <div>
                  <span className="block">Bramerijweg 15</span>
                  <span className="block">3555 HX, Utrecht</span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#2A2A2A] pt-8">
          <p className="text-[#BFBFBF] text-sm text-center">
            © {new Date().getFullYear()} cinewallkopen.nl – Alle rechten voorbehouden
          </p>
        </div>
      </div>
    </footer>
  );
}
